import { Link } from 'react-router-dom'
import './item-register.component.scss'

interface ItemRegisterProps extends React.HTMLAttributes<HTMLDivElement> {
  description: any
  completed: boolean
  position: number
  link: any
}

const ItemRegister = ({ description, completed, position, link }: ItemRegisterProps) => {
  return (
    <div className="box-item">
      {!completed ? (
        <Link to={link} className="display-flex align-items-center justify-content-space-between">
          <span className="display-flex justify-content-start align-items-center">
            <span className="icon-item mr-2 display-flex justify-content-start align-items-center">{position}</span>
            <span style={{ color: 'var(--text_color)' }} dangerouslySetInnerHTML={{ __html: description }}></span>
          </span>
          <i className="fa-solid fa-arrow-right-long box-item-icon" style={{ color: 'var(--primary_color)' }} />
        </Link>
      ) : (
        <span>
          <i className="fa-solid fa-circle-check green mr-2" style={{ fontSize: '1.3rem' }} />
          <span style={{ color: 'var(--text_color)' }} dangerouslySetInnerHTML={{ __html: description }}></span>
        </span>
      )}
    </div>
  )
}

export default ItemRegister
